import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ChannelsService } from '../../infrastructure/services/channels.service';
import { BuscadorPipe } from '../../helpers/pipes/buscador.pipe';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'config-sistema',
  templateUrl: './sistema.component.html',
  providers: [ChannelsService, BuscadorPipe]
})
export class SistemaComponent implements OnInit {
  codSubscription: string;
  channels: Observable<ItemGeneralListado[]>;
  constructor(private channelsService: ChannelsService, private aRoute: ActivatedRoute) { }
  ngOnInit(): void {
    this.aRoute.params.subscribe((params: Params) => {
      this.codSubscription = params['codsistema'];
      // this.negocios = this.negociosService.getNegocios(this.codSitema);
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/sistema.component.ts